import React, { useState } from "react";
import { Form } from "react-bootstrap";
import Purple_Btn from "../../../../common_components/common_btn/purple_btn/Purple_Btn";
import Purple_border_btn from "../../../../common_components/common_btn/purple_border_btn/Purple_border_btn";

import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Step3_Payment({
  goToStep,
  goToCartStep3,
  paymentMethod,
  setPaymentMethod,
  user,
}) {
  const [error, setError] = useState("");

  const handlePaymentChange = (value) => {
    setError("");
    setPaymentMethod(value);
  };

  return (
    <>
      <div className="content_box_holder mt-3">
        <div className="heading_strip_holder">
          <div className="content_strip_holder">
            <div>
              <h1>Account</h1>
            </div>
          </div>
          <hr />
        </div>

        <div className="content_strip_holder">
          <p>{user?.email}</p>
          {/* <FontAwesomeIcon icon={faPenToSquare} /> */}
        </div>
      </div>

      <div className="content_box_holder mt-3">
        <div className="row mb-3">
          <div className="col-md-6">
            <Form.Group controlId="bankTransfer" className="mb-3">
              <Form.Check
                name="group1"
                type="radio"
                label="Cash On Delivery"
                value="COD"
                checked={paymentMethod === "COD"}
                onChange={(e) => handlePaymentChange(e.target.value)}
              />
            </Form.Group>

            {/* {paymentMethod === "bank" && (
              <Form.Group className="mb-3">
                <div className="content_strip_holder">
                  <Form.Check
                    type="checkbox"
                    className="me-3"
                    checked={bankChecked}
                    onChange={(e) => setBankChecked(e.target.checked)}
                  />

                  <Form.Control
                    type="text"
                    value={bankText}
                    onChange={(e) => setBankText(e.target.value)}
                    placeholder="Enter Transaction / Reference No."
                  />
                </div>
              </Form.Group>
            )} */}
          </div>

          <div className="col-md-6">
            <Form.Group controlId="onlinePayment" className="mb-3">
              <Form.Check
                type="radio"
                name="group1"
                label="Online Payment"
                value="Online"
                checked={paymentMethod === "Online"}
                onChange={(e) => handlePaymentChange(e.target.value)}
              />
            </Form.Group>

            {/* {paymentMethod === "online" && (
              <p>
                You will be redirected to Razorpay Checkout page when you place
                an order.
              </p>
            )} */}
          </div>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <div className="btn_holder">
          {/* Back */}
          <div onClick={() => goToStep(2)}>
            <Purple_border_btn btnText="Back" />
          </div>

          {/* ✅ Continue → Step 4 Delivery */}
          {paymentMethod ? (
            <div onClick={goToCartStep3}>
              <Purple_Btn btnText="Continue" />
            </div>
          ) : (
            <div onClick={() => setError("Select Payment Method")}>
              <Purple_Btn btnText="Continue" />
            </div>
          )}
        </div>
      </div>

      {/* <div className="content_box_holder mt-3">
        <div className="heading_strip_holder">
          <div className="content_strip_holder">
            <h1>Payment</h1>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default Step3_Payment;
